/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Benefit_Focus_AnalysisInputs */

const en_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your best focus time, see the difference`)
};

const ar_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتشف أفضل أوقات تركيزك، ولاحظ الفرق`)
};

const de_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finden Sie Ihre beste Fokuszeit und sehen Sie den Unterschied`)
};

const es_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra el mejor momento para concentrarte y siente la diferencia`)
};

const fr_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez votre moment de concentration idéal, admirez vos progrès`)
};

const it_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova il momento migliore per concentrarti, guarda la differenza`)
};

const ja_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も集中できる時間帯を見つけて、違いを実感`)
};

const ko_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최고의 집중 시간을 경험하고 달라진 나를 발견하세요`)
};

const pt_br_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre seu melhor momento de foco, veja a diferença`)
};

const ru_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найдите лучшее время для фокусировки и почувствуйте разницу`)
};

const th_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาช่วงเวลาที่คุณโฟกัสได้ดีที่สุด แล้วสัมผัสกับความแตกต่าง`)
};

const tr_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En iyi odaklanma zamanını bul, farkı gör`)
};

const zh_cn_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找出最佳专注时段，专注更有感`)
};

const zh_tw_onboarding_paywall_benefit_focus_analysis = /** @type {(inputs: Onboarding_Paywall_Benefit_Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找出最佳專注時段，專注更有感`)
};

/**
* | output |
* | --- |
* | "Find your best focus time, see the difference" |
*
* @param {Onboarding_Paywall_Benefit_Focus_AnalysisInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_benefit_focus_analysis = /** @type {((inputs?: Onboarding_Paywall_Benefit_Focus_AnalysisInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Benefit_Focus_AnalysisInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "ar") return ar_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "de") return de_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "es") return es_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "fr") return fr_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "it") return it_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "ja") return ja_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "ko") return ko_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "ru") return ru_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "th") return th_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "tr") return tr_onboarding_paywall_benefit_focus_analysis(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_benefit_focus_analysis(inputs)
	return zh_tw_onboarding_paywall_benefit_focus_analysis(inputs)
});